import BossModeTable from './BossModeTable.component';

export default BossModeTable;